import { Progress } from 'antd';

type CompletionPercentageType = {
  percent: number;
  colorize?: boolean;
};


const CompletionPercentage = ({ percent, colorize = false, }: CompletionPercentageType) => {
  const rounded = Math.round(percent);

  const getStatus = (percent: number) =>
    percent <= 25 ? '#C81212' :
    percent <= 50 ? '#FFA500' :
    percent <= 75 ? '#1677FF' :
    percent <= 100 ? '#52c41a' : '#1677FF';

  const strokeColor = colorize ? getStatus(percent) : undefined;

  const progressStatus = colorize ? (value: number) => value === 100 ? 'success' : 'active' : undefined;

  return (
    <span className="flex justify-center w-full">
      <span className="flex items-center justify-between w-full max-w-[65px]">
        <Progress
          type="circle"
          percent={rounded}
          size={24}
          strokeWidth={16}
          showInfo={false}
          status={progressStatus?.(rounded)}
          strokeColor={strokeColor}
        />
        <span className="text-primary-100 font-medium">{rounded}%</span>
      </span>
    </span>
  );
};

export default CompletionPercentage;
